import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f5c3516"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-wrap" }
const _hoisted_2 = { class: "logo" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-wrap" }, [
  /*#__PURE__*/_createElementVNode("div", null, "此设备首年三责险已领取"),
  /*#__PURE__*/_createElementVNode("div", null, "（SN：887823423）")
], -1))

import {} from 'vue'
import { usePlatformInfo } from '@/compositions/common'
import Header from '@/components/Header.vue'
import IconCircleSuccess from '@/components/icon/IconCircleSuccess.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'message-center-transfer',
  setup(__props) {

const { isLandscape } = usePlatformInfo()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Header, { title: "免费领取第三者责任险" }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(IconCircleSuccess, {
          size: _unref(isLandscape) ? 64 : 80
        }, null, 8, ["size"])
      ]),
      _hoisted_3
    ])
  ], 64))
}
}

})